import { CacheProvider } from "@emotion/react"
import {
    FormControl,
    FormControlLabel,
    FormLabel,
    Radio,
    RadioGroup,
    TextField
} from "@mui/material"
import { useEffect, useMemo, useState } from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCircleInfo, faLocationDot, faPhone } from "@fortawesome/free-solid-svg-icons"
import { HeaderTitle } from "../../components/HeaderTitle"
import { IEvent } from "../../models/Event"
import { createTheme, ThemeProvider } from '@mui/material/styles';
import rtlPlugin from 'stylis-plugin-rtl';
import createCache from '@emotion/cache';
import { prefixer } from 'stylis';

const cacheRtl = createCache({
    key: 'muirtl',
    stylisPlugins: [prefixer, rtlPlugin],
});

export const Contact: React.FC<{ event: IEvent, pageHeader: Function }> = ({ event, pageHeader }) => {
    const [newForm, setNewForm] = useState(
        {
            fullName: '',
            roll: '',
            phoneNumber: '',
            email: '',
            competition: event.description,
            content: ''
        })

    const [contentErorr, setContentErorr] = useState(false)
    const [isSentModalOpen, setIsSentModalOpen] = useState(false)

    const theme = useMemo(() => createTheme({
        direction: 'rtl',
        shape: {
            borderRadius: 12
        },
        typography: {
            fontFamily: 'Rubik, system-ui, -apple-system, "Segoe UI", Arial, sans-serif'
        },
        palette: {
            primary: {
                main: `${event.backgroundColor}`
            }

        }
    }), [event.backgroundColor]);

    useEffect(() => {
        pageHeader("צור קשר")

    }, [])

    const handleChange = (ev: any) => {
        ev.preventDefault()
        const field = ev.target.name
        const value = ev.target.value
        setNewForm({ ...newForm, [field]: value })
        // console.log('newForm',newForm)
    }

    const onSubmit = async (ev: any) => {
        ev.preventDefault()
        if (newForm.content.length < 10) {
            setContentErorr(true)
            return
        }
        setContentErorr(false)
        let form = document.getElementById('contact-form')
        if (form) (form as HTMLFormElement).reset();

        setIsSentModalOpen(true)





        try {
            const response = await fetch(`https://www.4sport-live.com/miniSite/contact/?eventId=${event.eventId}`, {
                method: 'POST',
                credentials: 'omit',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    name: newForm.fullName,
                    mobile: newForm.phoneNumber,
                    email: newForm.email,
                    content: newForm.content,
                    roll: newForm.roll
                })
            })
            return {

            }
        } catch (error) {
            console.error(error);
        }


    }


    return (
        <div className="main-contact min-height">
            {isSentModalOpen && <div className="modal-backdrop" onClick={() => setIsSentModalOpen(false)}>
                <div className="modal-card" role="dialog" aria-modal="true" onClick={(ev) => ev.stopPropagation()}>
                    <button type="button" className="modal-close" aria-label="סגירה" onClick={() => setIsSentModalOpen(false)}>
                        <span className="material-icons">close</span>
                    </button>
                    <span className="material-icons modal-card__icon">check_circle</span>
                    <h2>
                        היי
                        {` ${newForm.fullName}`}
                        <br />
                        פנייתך התקבלה במערכת
                    </h2>
                </div>
            </div>}
            <HeaderTitle titleText={'צור קשר'} />
            <div className="container section--tight">
                <div className="contact-content">
                    <div className="card contact-form">
                        <ThemeProvider theme={theme}>
                            <CacheProvider value={cacheRtl}>
                                <form autoComplete="off" dir="rtl" id="contact-form" onSubmit={onSubmit} method="POST">
                                    <div dir="rtl" className="contact-container">
                                        <TextField onChange={(ev) => handleChange(ev)} id="outlined-basic"
                                            required
                                            // InputProps={{ inputProps: { min: 10, max: 20 } }}
                                            type="phoneNumber"

                                            label="שם מלא"
                                            name="fullName"
                                            variant="outlined"
                                            InputLabelProps={{ style: { color: '#222222' } }}
                                        />
                                        <TextField onChange={(ev) => handleChange(ev)} id="outlined-basic"
                                            required
                                            label="מספר טלפון"
                                            name="phoneNumber"
                                            InputProps={{ inputProps: { min: 0, max: 10 } }}
                                            variant="outlined"
                                            type="tel"
                                            InputLabelProps={{ style: { color: '#222222' } }} />
                                        <TextField onChange={(ev) => handleChange(ev)} id="outlined-basic"
                                            required
                                            label="כתובת אימייל"
                                            name="email"
                                            variant="outlined"
                                            type="email"
                                            InputLabelProps={{ style: { color: '#222222' } }} />
                                        <TextField onChange={(ev) => handleChange(ev)} id="outlined-basic" label="  תוכן (לפחות 10 תווים)"
                                            required
                                            multiline rows={4} name="content" variant="outlined"
                                            InputLabelProps={{ style: { color: '#222222' } }}
                                            error={contentErorr}
                                        />
                                    </div>
                                    <FormControl>
                                        <FormLabel className="contact-heats-label" id="demo-radio-buttons-group-label">מקצה *</FormLabel>
                                        <RadioGroup onChange={(ev) => handleChange(ev)}
                                            name="roll"
                                            aria-labelledby="demo-radio-buttons-group-label"
                                            defaultValue="female"
                                            aria-required
                                        >
                                            <div dir="rtl" className="contact-heats">
                                                {event.heats.map(heat =>
                                                    <FormControlLabel onChange={(ev) => handleChange(ev)} name="roll" key={heat.description} value={heat.description} control={<Radio required={true} />}
                                                        label={heat.description} />
                                                )}
                                            </div>
                                        </RadioGroup>
                                    </FormControl>
                                    <button className="btn btn-primary btn-lg" type="submit">שלח</button>
                                </form>
                            </CacheProvider>
                        </ThemeProvider>
                    </div>
                    <aside className="contact-aside">
                        {event.contactImage && <img className="contact-img" src={event.contactImage} alt="" />}
                        <ul className="contact-boxes-container">
                            {event.contactPhone && <li className="contact-box">
                                <span className="contact-box__icon"><FontAwesomeIcon icon={faPhone} /></span>
                                <a href={`tel:${event.contactPhone}`} dir="ltr">{event.contactPhone}</a>
                            </li>}
                            {event.location && <li className="contact-box">
                                <span className="contact-box__icon"><FontAwesomeIcon icon={faLocationDot} /></span>
                                <span>{event.location}</span>
                            </li>}
                            {event.organizerDetails && <li className="contact-box">
                                <span className="contact-box__icon"><FontAwesomeIcon icon={faCircleInfo} /></span>
                                <span>{event.organizerDetails}</span>
                            </li>}
                        </ul>
                    </aside>
                </div>
            </div>
        </div>
    )
}
